import { MappingManagerTemplateStatusType } from '../../../types/external'
import type { UserState } from '../../../types/external'
import type { MarketplaceTemplatesDetailsData } from '../types'
import { resolveCreatedByForDisplay } from './resolveCreatedByForDisplay'

export const mapSalesforceTemplatesToDetails = (
  templates: any[],
  usersData: UserState[]
): MarketplaceTemplatesDetailsData[] =>
  templates.map((template: any) => ({
    templateName: template.name,
    templateId: template.id,
    templateType: template.templateType || '-',
    status: template.isDraft
      ? MappingManagerTemplateStatusType.DRAFT
      : MappingManagerTemplateStatusType.ACTIVE,
    createdBy: resolveCreatedByForDisplay(
      template.createdByDisplay,
      template.createdBy,
      usersData
    ),
    creationDate: template.createdAt,
    cloudProvider: template.cloudProvider,
    lastUpdatedAt: template.updatedAt || template.createdAt,
    accountId: template.accountId,
  }))
